import Onboarding from "./Onboarding"

export default Onboarding
